import { parseConfig } from '@office-start/config-parser-utility';
import { getErrorHandler } from '@office-start/error-handler';
var masterCollection;
// TODO: Figure out how to get first visit when storage dump is not in page response
var firstUse;
var firstUseTimestamp;
var initialized = false;
function ensureInitialized() {
    if (initialized) {
        return;
    }
    initialized = true;
    var cache = undefined;
    try {
        cache = parseConfig('userStorageCache');
    }
    catch (error) {
        getErrorHandler().handleError(error);
    }
    masterCollection = cache ? cache.content : {};
    firstUse = cache ? cache.firstUse : false;
    firstUseTimestamp = cache ? cache.firstUseTimestamp : 0;
}
export function getMasterCollection() {
    ensureInitialized();
    return masterCollection;
}
export function isFirstUse() {
    ensureInitialized();
    return firstUse;
}
// TODO: handle in user-profile service as that's the document this belongs to
export function getFirstUseTimestamp() {
    ensureInitialized();
    return firstUseTimestamp;
}
//# sourceMappingURL=UserStorageService.js.map